module.exports = __webpack_public_path__ + "static/media/exchange_op.32e3426e.svg";